import {Platform, StyleSheet, View, Pressable} from 'react-native';
import {ScreenProps} from 'src/types/Screen';
import Swipeable from 'react-native-gesture-handler/ReanimatedSwipeable';
import RenderRightDelectActions from 'src/components/elements/RenderRightDelectActions';
import {useDeleteSwipe} from '../../hooks';
import DealItem from 'src/components/elements/promotions/dealItem/DealItem';
import DealItemCanteen from 'src/components/elements/promotions/dealItem/DealItemCanteen';
import Settings from 'src/Settings';
import {GiftItem} from 'src/types/snack/GiftItem';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../../i18n/HOC/withGlobalize';

const DealItemSwipeAble = (
  props: ScreenProps &
    WithGlobalizeProps & {
      item: GiftItem;
      selectedItemIndex: number;
      onDelete?: () => void;
      onPress: () => void;
    },
) => {
  const [
    maxSwipeDistance,
    screenWidth,
    swipeableRef,
    handleSwipeStart,
    handleSwipeEnd,
    handlePress,
  ] = useDeleteSwipe({onPress: props.onPress});

  const isRefiveAnd365Pay = Settings.isRefiveAnd365Pay();

  return (
    <>
      <Swipeable
        enabled={!!props.onDelete}
        onSwipeableWillOpen={handleSwipeStart}
        onSwipeableClose={handleSwipeEnd}
        ref={swipeableRef}
        renderRightActions={(progressAnimatedValue, dragAnimatedValue) => (
          <RenderRightDelectActions
            dragAnimatedValue={dragAnimatedValue}
            onPress={() => {
              swipeableRef.current?.close();
              props.onDelete();
            }}
          />
        )}
        containerStyle={{
          width: Platform.OS === 'web' ? undefined : screenWidth,
        }}
        rightThreshold={maxSwipeDistance}
        overshootRight={false}
      >
        {!isRefiveAnd365Pay && (
          <Pressable onPress={handlePress}>
            <DealItemCanteen
              dealItem={props.item}
              selectedItemIndex={props.selectedItemIndex}
              key={props.item.externalServiceId}
              {...props}
              onPress={(dealItem, selectedItemIndex) => handlePress()}
            />
          </Pressable>
        )}
        {isRefiveAnd365Pay && (
          <Pressable onPress={handlePress}>
            <DealItem
              dealItem={props.item}
              selectedItemIndex={props.selectedItemIndex}
              key={props.item.externalServiceId}
              {...props}
              onPress={(dealItem, selectedItemIndex) => handlePress()}
            />
          </Pressable>
        )}
      </Swipeable>
      {!Settings.isRefiveAnd365Pay() && (
        <View style={styles.lineWrapper}>
          <View style={styles.line} />
        </View>
      )}
    </>
  );
};
const styles = StyleSheet.create({
  lineWrapper: {
    width: '100%',
    paddingHorizontal: 20,
  },
  line: {
    width: '100%',
    borderBottomWidth: 1,
    borderBottomColor: '#9A9A9F',
  },
});
export default withGlobalize(DealItemSwipeAble);
